
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import ObjectInfoTitle from './ObjectInfoTitle';
import LinkToTeleso from './LinkToTeleso';

const classNames = mergeStyleSets({
    list: {
        overflowY: 'auto',
        maxHeight: 200
    },
    parcelaKatuzeNazev: {
        width: 150
    },
    cisloTel: {
        width: 100
    }
});

const ObjectInfoTelesoItem = (props) => {
    return (
        <Stack horizontal>
            <Stack.Item className={classNames.parcelaKatuzeNazev}>
                {props.item.katuze_nazev}
            </Stack.Item>
            <Stack.Item className={classNames.cisloTel}>
                <LinkToTeleso tel={props.item} />
            </Stack.Item>
        </Stack>
    );
}

const ObjectInfoTelesa = (props) => {

    return (props.tel.length > 0)
        ? <Stack verticalfill>
            <Stack.Item>
                <ObjectInfoTitle title="LISTY VLASTNICTVÍ" />
            </Stack.Item>
            <Stack.Item grow className={classNames.list}>
                {props.tel.map(item => {
                    return (
                        <ObjectInfoTelesoItem key={item.id} item={item} />
                    )
                })}
            </Stack.Item>
        </Stack>
        : null;
}

export default ObjectInfoTelesa;
